// extracted by mini-css-extract-plugin
module.exports = {"sectionButton":"sectionButton--1vIRg","selected":"selected--1rvEW","selectedSpecial":"selectedSpecial--1w1YJ","checkIcon":"checkIcon--2cfgE","isSpecial":"isSpecial--3a3y2"};